/**
 * Created by wuyanbin on 2019/7/15
 */
import { CHECK_VALUE_INTEGER_MAXVAL_NO_ZERO } from '@/shared/reqexp';
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import React, { Component } from 'react';
import { Input, Form } from 'antd';
const mapStateToProps = (rootState) => ({
    sellerPayRules: rootState.sellerPayRules,
});
class FixedFeeComponent extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (e) => {
            dispatch.sellerPayRules.handleFixedFeeMoney(e.target.value);
        };
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { fixedFeeMoney, isEditAble } = this.props.sellerPayRules;
        return (<Form.Item style={{ marginTop: '-4px' }}>
        {getFieldDecorator('fixedFeeMoney', {
            initialValue: fixedFeeMoney,
            rules: [
                { pattern: CHECK_VALUE_INTEGER_MAXVAL_NO_ZERO,
                    message: '请输入不超过999999的正整数(不包含0)',
                },
            ],
        })(<Input disabled={!isEditAble} addonAfter="元/车" placeholder="请输入金额" onChange={this.onChange}/>)}
      </Form.Item>);
    }
}
export default connect(mapStateToProps)(FixedFeeComponent);
